import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/Headers/PageHeader";
import PageMain from "../../../components/Main/PageMain";
import useFetch from "../../../hooks/useFetch";
import * as api from "../../../constants/api";
import Spinner from "../../../components/Spinner";
import FriendlyInfo from "../../../components/FriendlyInfo";
import ButtonsArea from "../../../components/Buttons/ButtonsArea";
import RoundButton from "../../../components/Buttons/RoundButton";
import { useNavigate } from "react-router";
import * as r from "../../../constants/routes";
import classes from "./Dashboard.module.scss";
import * as Auth from "@aws-amplify/auth";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import email_icon from "./../../../assets/images/email_icon.svg";
import users_icon from "./../../../assets/images/user_icon.svg";
import admin_icon from "./../../../assets/images/admin_icon.svg";
import painel_icon from "./../../../assets/images/painel_icon.svg";
import favicon from "./../../../assets/images/logo_audiofoco.svg";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import SessionContext from "../../../context/sessionContext";

export default function Dashboard() {
  const { t } = useTranslation();
  const history = useNavigate();
  const [open, setOpen] = useState(true);
  // const [handleQuantity, setHandleQuantity] = useState<string | number>(0);
  const cSession = useContext(SessionContext);
  const [is_manager, set_ismaneger] = useState(false);
  const [attributes, set_attributes] = useState(false);
  const [isLoadingattributes, set_isLoadingattributes] = useState(false);

  if (cSession.is_session_active) Auth.fetchAuthSession().then((session) => {
    set_isLoadingattributes(true);
    if (session && session.userSub)
      if (!attributes && !isLoadingattributes) Auth.fetchUserAttributes().then(attributes => {
        set_attributes(!!attributes);
        set_ismaneger(attributes["custom:is_manager"] === "True" ? true : false)
        set_isLoadingattributes(false);
      })
  });
  const [companyInfo, , hasError]: any = useFetch({
    url: api.API_COMPANY_INFO,
  });
  const company_uid = cSession?.company_uid;

  let _content = <Spinner center />;

  if (companyInfo) {
    let _manageUsers = null;
    const { plan_permission } = companyInfo ?? {};
    localStorage.setItem("plan_permission", plan_permission);
    if (plan_permission === "01") {
      const { limit_users, users_registered } = companyInfo ?? {};
      const totalActiveUsers =
        parseInt(limit_users) - parseInt(users_registered);
      const infoUsers =
        totalActiveUsers > 0 ? (
          <p className={classes.ColumnInfo}>
            {t("global.your_company_could_have") + " "}
            <span style={{ whiteSpace: "nowrap", color: "#27AE60", textAlign: "left" }}>
              <strong>{totalActiveUsers}</strong>
              {" " + t("global.new_active_users")}
            </span>
          </p>
        ) : (
          <p style={{ color: "red" }}>
            {t("global.your_company_reach_number_active_users_added")}
          </p>
        );
      // está sem estilização
      _manageUsers = (
        <>
          <ButtonsArea className={classes.ColumnTwoButtons}>
            <div className={classes.usersButtons}>
              <ButtonsArea className={classes.ColumnRight}>
                <div className={classes.CardTitle}>
                  <img src={users_icon} />
                  <p>{t("painel.go_users")}</p>
                </div>
                {infoUsers}
                <p className={classes.ColumnInfo}></p>
                <RoundButton
                  className={classes.ColumnRight}
                  onClick={() => history(r.R_A_USERS_LIST)}
                  text={t("painel.manage")}
                  title={t("global.manage_all_users")}
                />
              </ButtonsArea>
              <ButtonsArea className={classes.ColumnRight}>
                <div className={classes.CardTitle}>
                  <img src={painel_icon} />
                  <p>{t("painel.general_dash")}</p>
                </div>
                <p>Acessar relatório geral dos usuários</p>
                <RoundButton
                  className={classes.ColumnRight}
                  onClick={() => history(r.R_A_FILTERS_DASHBOARD)}
                  text={t("painel.access")}
                  title={t("global.buy")}
                />
              </ButtonsArea>
              <ButtonsArea className={classes.ColumnCenter}>
                {is_manager && (
                  <>
                    <div className={classes.CardTitle}>
                      <img src={admin_icon} />
                      <p>{t("painel.admin")}</p>
                    </div>
                    <p>{t("painel.admin_info")}</p>
                    <RoundButton
                      onClick={() => history(r.R_A_PRO_LIST)}
                      text={t("painel.access")}
                      title={t("global.manage_all_admin")}
                    />
                    {/* <div className={classes.Divisor} /> */}
                  </>
                )}
              </ButtonsArea>
            </div>
          </ButtonsArea>
        </>
      );
    } else if (plan_permission === "10") {
      const { owned_journeys } = companyInfo ?? {};

      const infoUsers =
        owned_journeys > 0 ? (
          <p className={classes.ColumnInfo}>
            {t("global.your_company_could_have") + " "}
            <span style={{ whiteSpace: "nowrap", color: "#27AE60", textAlign: "left" }}>
              <strong >{owned_journeys}</strong>
              {" " + t("global.new_active_users")}
            </span>
          </p>
        ) : (
          <p className={classes.ColumnInfo}>
            {t("global.your_company_reach_number_active_users_added")}
          </p>
        );
      _manageUsers = (
        <>
          <ButtonsArea className={classes.ColumnTwoButtons}>
            <div className={classes.usersButtons}>
              <ButtonsArea className={classes.ColumnRight}>
                <div className={classes.CardTitle}>
                  <img src={users_icon} />
                  <p>{t("painel.smart_users")}</p>
                </div>
                {infoUsers}
                <p className={classes.ColumnInfo}></p>
                <RoundButton
                  className={classes.ColumnRight}
                  onClick={() => history(r.R_A_USERS_LIST_SMART)}
                  text={t("painel.manage")}
                  title={t("global.manage_all_users")}
                />
              </ButtonsArea>
              <ButtonsArea className={classes.ColumnRight}>
                <div className={classes.CardTitle}>
                  <img src={painel_icon} />
                  <p>{t("painel.general_dash")}</p>
                </div>
                <p>Acessar relatório geral dos usuários</p>
                <RoundButton
                  className={classes.ColumnRight}
                  onClick={() => history(r.R_A_FILTERS_DASHBOARD)}
                  text={t("painel.access")}
                  title={t("global.buy")}
                />
              </ButtonsArea>
              <ButtonsArea className={classes.ColumnCenter}>
                {is_manager && (
                  <>
                    <div className={classes.CardTitle}>
                      <img src={admin_icon} />
                      <p>{t("painel.admin")}</p>
                    </div>
                    <p>{t("painel.admin_info")}</p>
                    <RoundButton
                      onClick={() => history(r.R_A_PRO_LIST)}
                      text={t("painel.access")}
                      title={t("global.manage_all_admin")}
                    />
                    {/* <div className={classes.Divisor} /> */}
                  </>
                )}
              </ButtonsArea>
            </div>
            {is_manager && (
              <>
                <div className={classes.buyColumnCard}>
                  <p>{t("painel.buy_journey")}</p>
                  <ButtonsArea className={classes.buyColumn}>
                    <div className={classes.Description}>
                      <img src={favicon} />
                      <div>
                        <p>{t("painel.buy_journey_info")}</p>
                        <p>{t("painel.buy_journey_info_2")}</p>
                      </div>
                    </div>
                    <button
                      className={classes.buyColumnButton}
                      onClick={() => {
                        history(r.R_U_PURCHASE);
                      }}
                      title={t("global.buy")}
                    >
                      {t("global.buy")}
                    </button>
                  </ButtonsArea>
                </div>
              </>
            )}
          </ButtonsArea>
        </>
      );
    } else if (plan_permission === "11") {
      const {
        limit_users,
        limit_users_smart,
        users_registered,
        users_registered_smart,
        owned_journeys,
      } = companyInfo ?? {};

      const totalActiveUsersSmart =
        parseInt(limit_users_smart) - parseInt(users_registered_smart);

      const infoUsers =
        limit_users > 0 ? (
          <p className={classes.ColumnInfo}>
            {t("global.your_company_could_have") + " "}
            <span style={{ whiteSpace: "nowrap", color: "#27AE60", textAlign: "left" }}>
              <strong>{limit_users}</strong>
              {" " + t("global.new_active_users")}
            </span>
          </p>
        ) : (
          <p className={classes.ColumnInfo}>
            {t("global.your_company_reach_number_active_users_added")}
          </p>
        );
      const infoUsersSmart =
        owned_journeys > 0 ? (
          <p className={classes.ColumnInfo}>
            {t("global.your_company_could_have") + " "}
            <span style={{ whiteSpace: "nowrap", color: "#27AE60", textAlign: "left" }}>
              <strong>{owned_journeys}</strong>
              {" " + t("global.new_active_journeys")}
            </span>
          </p>
        ) : (
          <p className={classes.ColumnInfo}>
            {t("global.your_company_reach_number_active_users_added")}
          </p>
        );
      _manageUsers = (
        <>
          <ButtonsArea className={classes.ColumnTwoButtons}>
            <div className={classes.usersButtons}>
              <ButtonsArea className={classes.ColumnRight}>
                <div className={classes.CardTitle}>
                  <img src={users_icon} />
                  <p>{t("painel.smart_users")}</p>
                </div>
                {infoUsersSmart}
                <p className={classes.ColumnInfo}></p>
                <RoundButton
                  className={classes.ColumnRight}
                  onClick={() => history(r.R_A_USERS_LIST_SMART)}
                  text={t("painel.manage")}
                  title={t("global.manage_all_users")}
                />
              </ButtonsArea>
              <ButtonsArea className={classes.ColumnLeft}>
                <div className={classes.CardTitle}>
                  <img src={users_icon} />
                  <p>{t("painel.go_users")}</p>
                </div>
                <div className={classes.PlanCapacity}>
                  {infoUsers}
                  <p className={classes.ColumnInfo}>
                    <em style={{ color: "red", fontSize: "12px", textAlign: "left" }}>
                      *({t("global.plan_capacity") + " "}
                      {users_registered}
                      {" " + t("global.of") + " "}
                      {limit_users}
                      {" " + t("global.active_users").toLowerCase()})
                    </em>
                  </p>
                </div>
                <RoundButton
                  //className={classes.ColumnLeft}
                  onClick={() => history(r.R_A_USERS_LIST)}
                  text={t("painel.manage")}
                  title={t("global.manage_all_users")}
                />
              </ButtonsArea>
              <ButtonsArea className={classes.ColumnRight}>
                <div className={classes.CardTitle}>
                  <img src={painel_icon} />
                  <p>{t("painel.general_dash")}</p>
                </div>
                <p>{t("painel.general_dash_info")}</p>
                <RoundButton
                  className={classes.ColumnRight}
                  onClick={() => history(r.R_A_FILTERS_DASHBOARD)}
                  text={t("ACESSAR")}
                  title={t("global.buy")}
                />
              </ButtonsArea>
            </div>
            {is_manager &&
              <ButtonsArea className={classes.ColumnCenter}>
                <>
                  <div className={classes.CardTitle}>
                    <img src={users_icon} />
                    <p>{t("painel.admin")}</p>
                  </div>
                  <p>{t("painel.admin_info")}</p>
                  <RoundButton
                    onClick={() => history(r.R_A_PRO_LIST)}
                    text={t("painel.manage")}
                    title={t("global.manage_all_admin")}
                  />
                </>
              </ButtonsArea>
            }
            {is_manager && (
              <>
                <div className={classes.buyColumnCard}>
                  <p>{t("painel.buy_journey")}</p>
                  <ButtonsArea className={classes.buyColumn}>
                    <div className={classes.Description}>
                      <img src={favicon} />
                      <div>
                        <p>{t("painel.buy_journey_info")}</p>
                        <p>{t("painel.buy_journey_info_2")}</p>
                      </div>
                    </div>
                    <button
                      className={classes.buyColumnButton}
                      onClick={() => {
                        history(r.R_U_PURCHASE);
                      }}
                      title={t("global.buy")}
                    >
                      {t("global.buy")}
                    </button>
                  </ButtonsArea>
                </div>
              </>
            )}
          </ButtonsArea>
        </>
      );
    }
    _content = (
      <div className={classes.DashboardArea}>
        <div className={classes.Dashboard}>{_manageUsers}</div>
      </div>
    );
  } else if (hasError) {
    _content = <FriendlyInfo text={t("infos.something_wrong_try_again")} />;
  }

  return (
    <>
      <PageHeader
        title={t("global.welcome") + ","}
        subtitle={t("global.what_you_would_to_do_today")}
      />
      <PageMain center>
        <>{_content}</>
      </PageMain>
    </>
  );
}
